
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"62","height":"63","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M31 57.333c14.267 0 25.833-11.566 25.833-25.833C56.833 17.233 45.267 5.667 31 5.667 16.733 5.667 5.167 17.233 5.167 31.5c0 14.267 11.566 25.833 25.833 25.833zm9.577-35.41a2.583 2.583 0 010 3.654L34.653 31.5l5.924 5.923a2.583 2.583 0 11-3.654 3.654L31 35.153l-5.923 5.924a2.583 2.583 0 01-3.654-3.654l5.924-5.923-5.924-5.923a2.583 2.583 0 013.654-3.654L31 27.847l5.923-5.924a2.583 2.583 0 013.654 0z","fill":"#313131"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .5)","d":"M0 0h62v62H0z"}})])])]);
        };
      

        module.exports = {
          
          render: render,
        };
      